export default function ({ path, meta: { storeFn } }) {
  const includesMonoOrNew = path.includes('mono') || path.includes('new')

  if (!includesMonoOrNew) {
    if (storeFn) storeFn().form.item = null
  }
  return
}
